/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ExternalRequirement/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function ExternalRequirement({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CheckRequirements/Requirements/Requirement/Info/ExternalRequirement"
  
}) {
let requirementNameValueData = fromData.useDataValue({ viewPath,
context: 'requirement',
path: 'name',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="requirement.name"
 text={requirementNameValueData}
 size="xmedium"
 weight="semibold"
/>
{children}
</React.Fragment>)
}